import Charts from './Charts.yaml?component';

export { Charts };
